import { put, takeLatest, call, takeEvery, select } from "redux-saga/effects";
import * as types from "../constants/ShootsActionTypes";
import shootService from "../../services/shootService";
import questionService from "../../services/questionService";
import update from "immutability-helper";

function* fetchOneShoot(action) {
  try {
    let { clinic, created_at } = action;
    let { data } = yield call(shootService.getOneShoot, {
      clinic,
      created_at
    });
    yield put({ type: types.SHOOTS_GET_ONE_SUCCESS, shoot: { ...data } });
  } catch (err) {
    console.log(err);
  }
}

function* startShoot(action) {
  try {
    let { clinic, created_at, body } = action;
    yield call(
      shootService.updateShoot,
      {
        clinic,
        created_at
      },
      {
        ...body
      }
    );
    yield put({ type: types.SHOOTS_START_SUCCESS });
    yield put({ type: types.SHOOTS_GET_ONE, clinic, created_at });
  } catch (err) {
    console.log(err);
  }
}

function* getShootShots(action) {
  try {
    console.log("getting shots in saga");
    let { data } = yield call(
      shootService.getShootShots,
      {
        clinic: action.clinic,
        created_at: action.created_at
      },
      {
        params: {
          shot_type: action.shot_type
        }
      }
    );

    data = yield data.map(shot => {
      return {
        ...shot,
        selected: false
      };
    });
    let shots = yield data;
    yield put({
      type: types.SHOOTS_GET_SHOTS_SUCCESS,
      shot_type: action.shot_type,
      shots
    });
  } catch (err) {
    console.log("Failed getting shots");
    console.log(err);
  }
}

function* removeShotsFromShoot(action) {
  try {
    let { shot_type, clinic, created_at } = yield action;
    let { data } = yield select(state => state.selectedShoot.shots[shot_type]);
    let filteredShots = yield data.filter(value => value.selected);
    let removeShots = yield filteredShots.map(shot => `${shot.priority ? "1" : "2"}:${shot.shot_id}`);
    yield call(
      shootService.deleteShootShots,
      {
        clinic,
        created_at
      },
      removeShots,
      {
        params: {
          shot_type: shot_type
        }
      }
    );
    yield put({ type: types.SHOOTS_REMOVE_SHOTS_SUCCESS });
    yield getShootShots(action);
  } catch (err) {
    console.log("failed removing shots from shoot");
    console.log(err);
  }
}

function* handleApproveShots(action) {
  try {
    let { clinic, created_at, shot_type, data } = yield action;
    let shots = data.filter(shot => shot.selected);
    shots = yield shots.map(shot => {
      let { shot_type, shot_id, priority } = shot;
      return {
        approved: true,
        checked: true,
        shot_type,
        shot_id,
        priority
      };
    });
    yield call(
      shootService.checkShootShot,
      {
        clinic,
        created_at
      },
      {
        shots
      }
    );

    yield put({
      type: types.SHOOTS_CHECK_APPROVE_SUCCESS,
      shot_type
    });

    yield put({
      type: types.SHOOTS_GET_SHOTS,
      clinic,
      created_at,
      shot_type
    });
  } catch (err) {
    console.log(err);
  }
}

function* handleRejectShots(action) {
  try {
    let { clinic, created_at, shot_type, data } = yield action;
    let shots = data.filter(shot => shot.selected);
    shots = yield shots.map(shot => {
      let { shot_type, shot_id, priority } = shot;
      return {
        approved: false,
        checked: true,
        shot_type,
        shot_id,
        priority
      };
    });
    yield call(
      shootService.checkShootShot,
      {
        clinic,
        created_at
      },
      {
        shots
      }
    );
    yield put({
      type: types.SHOOTS_CHECK_REJECT_SUCCESS,
      shot_type
    });

    yield put({
      type: types.SHOOTS_GET_SHOTS,
      clinic,
      created_at,
      shot_type
    });
  } catch (err) {}
}

function* markShootComplete(action) {
  try {
    let { clinic, created_at, shoot } = yield action;
    let { address, date, status } = shoot;
    let result = yield call(
      shootService.markShootComplete,
      {
        clinic,
        created_at
      },
      {
        address,
        date,
        status: "COMPLETED"
      }
    );
    console.log(result);
    yield put({
      type: types.SHOOTS_MARK_SHOOT_COMPLETE_SUCCESS
    });

    yield put({
      type: types.SHOOTS_GET_ONE,
      clinic,
      created_at
    });
  } catch (err) {
    console.log(err);
  }
}

function* getShootStatus(action) {
  try {
    let { clinic, created_at } = yield action;
    let { data } = yield call(shootService.getShootStatus, {
      clinic,
      created_at
    });
    let status = data;
    yield put({
      type: types.SHOOT_GET_STATUS_SUCCESS,
      status
    });
  } catch (err) {}
}

function* updateShootPriority({ type, shot_type, id, priority, newPriority, clinic, created_at }) {
  try {
    yield call(
      shootService.updateShootShotPriority,
      {
        clinic,
        created_at,
        shotId: id
      },
      {
        priority: newPriority
      },
      {
        params: {
          shot_type,
          priority
        }
      }
    );
    yield put({
      type: types.SHOOT_UPDATE_SHOT_PRIORITY_SUCCESS
    });
    yield put({
      type: types.SHOOTS_GET_SHOTS,
      clinic,
      created_at,
      shot_type
    });
  } catch (err) {
    console.log(err);
  }
}

function* getShootQuestions({ clinic, created_at }) {
  try {
    let { data } = yield call(questionService.getShootQuestions, {
      clinic,
      created_at
    });
    console.log(data);
    data = data.map(item => {
      item.selected = false;
      return item;
    });
    let positions = data.map(item => item.position).filter((value, index, array) => array.indexOf(value) === index);
    yield put({
      type: types.SHOOT_GET_QUESTION_SUCCESS,
      data,
      positions
    });
  } catch (err) {
    console.log(err);
  }
}

function* handleShootQuestionCheckbox({ id }) {
  try {
    let { data, selectedQuestions } = yield select(state => state.selectedShoot.questions);
    if (selectedQuestions.includes(id)) {
      let index = selectedQuestions.indexOf(id);
      console.log(selectedQuestions);
      let newOutput = update({ selectedQuestions }, { selectedQuestions: { $splice: [[index, 1]] } });
      selectedQuestions = newOutput.selectedQuestions;
    } else {
      selectedQuestions = selectedQuestions.concat(id);
    }
    yield put({
      type: types.SHOOT_QUESTION_SET_SELECTEDQUESTIONS,
      selectedQuestions
    });
  } catch (err) {
    console.log(err);
  }
}

function* removeQuestionsFromShoot({ clinic, created_at }) {
  try {
    let { data, selectedQuestions } = yield select(state => state.selectedShoot.questions);
    let questions = yield data
      .filter(question => selectedQuestions.includes(question.id))
      .map(question => `${question.position}:detail:${question.id}`);
    yield console.log(questions);
    yield call(
      shootService.deleteQuestionFromShoot,
      {
        clinic,
        created_at
      },
      { questions }
    );
    yield put({
      type: types.SHOOT_QUESTION_REMOVE_SUCCESS
    });
    yield put({
      type: types.SHOOT_GET_QUESTION,
      clinic,
      created_at
    });
  } catch (err) {
    console.log(err);
  }
}

function* getShootPackages({ clinic, created_at, shot_type }) {
  try {
    let { data } = yield call(shootService.getShootPackages, {
      clinic,
      created_at
    }, {
      params: {
        type: shot_type
      }
    });
    // console.log(data);
    yield put({
      type: types.SHOOT_GET_PACKAGES_SUCCESS,
      data,
      shot_type
    });
  } catch (err) {
    console.log(err);
  }
}

//watchers

function* getShootStatusWatcher() {
  yield takeEvery(types.SHOOT_GET_STATUS, getShootStatus);
}

function* fetchOneShootWatcher() {
  yield takeLatest("SHOOTS_GET_ONE", fetchOneShoot);
}

function* startShootWatcher() {
  yield takeLatest(types.SHOOTS_START, startShoot);
}

function* getShootShotsWatcher() {
  yield takeLatest(types.SHOOTS_GET_SHOTS, getShootShots);
}

function* removeShotsFromShootWatcher() {
  yield takeLatest(types.SHOOTS_REMOVE_SHOTS, removeShotsFromShoot);
}

function* handleApproveShotsWatcher() {
  yield takeLatest(types.SHOOTS_CHECK_APPROVE, handleApproveShots);
}

function* handleRejectShotsWatcher() {
  yield takeLatest(types.SHOOTS_CHECK_REJECT, handleRejectShots);
}

function* markShootCompleteWatcher() {
  yield takeLatest(types.SHOOTS_MARK_SHOOT_COMPLETE, markShootComplete);
}

function* updateShootPriorityWatcher() {
  yield takeLatest(types.SHOOT_UPDATE_SHOT_PRIORITY, updateShootPriority);
}

function* getShootQuestionsWatcher() {
  yield takeLatest(types.SHOOT_GET_QUESTION, getShootQuestions);
}

function* handleShootQuestionCheckboxWatcher() {
  yield takeLatest(types.SHOOT_QUESTION_HANDLE_CHECKBOX, handleShootQuestionCheckbox);
}

function* removeQuestionsFromShootWatcher() {
  yield takeLatest(types.SHOOT_QUESTION_REMOVE, removeQuestionsFromShoot);
}

function* getShootPackagesWatcher() {
  // yield takeLatest(types.SHOOT_QUESTION_REMOVE, getShootPackages);
  yield takeLatest(types.SHOOT_GET_PACKAGES, getShootPackages);
}

export default {
  fetchOneShootWatcher,
  startShootWatcher,
  getShootShotsWatcher,
  removeShotsFromShootWatcher,
  handleApproveShotsWatcher,
  handleRejectShotsWatcher,
  markShootCompleteWatcher,
  getShootStatusWatcher,
  updateShootPriorityWatcher,
  getShootQuestionsWatcher,
  handleShootQuestionCheckboxWatcher,
  removeQuestionsFromShootWatcher,
  getShootPackagesWatcher
};
